import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Image, Media } from '@shared/models/card.model';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss'],
})
export class GalleryComponent {
  public images: Image[];
  public media: Media[];
  public current: number;
  public isMobile: boolean;
  public iframeUrl: SafeResourceUrl;

  constructor(
    public dialogRef: MatDialogRef<GalleryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _sanitizer: DomSanitizer
  ) {
    this.current = data.i;
    this.images = data.images;
    this.media = data.media;
    this.isMobile =
      /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
  }

  imageMediaLength() {
    return this.images.length + this.media.length;
  }

  sanitizeVideoUrl(videoURL: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl(
      videoURL.replace('watch?v=', 'embed/')
    );
  }

  navForward(): void {
    this.current =
      this.current + 1 < this.imageMediaLength() ? this.current + 1 : 0;
    if (this.current >= this.images.length) {
      this.iframeUrl = this.sanitizeVideoUrl(
        this.media[this.current - this.images.length].url
      );
    }
  }

  navBackward(): void {
    this.current =
      this.current - 1 >= 0 ? this.current - 1 : this.imageMediaLength() - 1;
    if (this.current >= this.images.length) {
      this.iframeUrl = this.sanitizeVideoUrl(
        this.media[this.current - this.images.length].url
      );
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
